import React, { useLayoutEffect, useState } from "react";
import { Alert, Button, Card, CardBody, CardText, CardTitle, Col, Row, Table, UncontrolledTooltip } from "reactstrap";
import styles from "./style.module.scss";
import cx from "classnames";
import { getPoBoxesByDate } from "api/POBoxApi";
import { errorHandler } from "utils/Api";
import moment from "moment";
import { PO_BOX_PREFIX } from "utils/Constants";

const NewUserPOBoxes = (props) => {
  const { className } = props;
  const [poBoxes, setPoBoxes] = useState([]);
  const [groupBydate, setGroupBydate] = useState({});


  useLayoutEffect(() => {
    fetchLastestPOBoxe();
  }, []);


  /**
   * Filtra los elementos creados antes de cierta cantidad de días.
   *
   * @param {Array} items - Lista de objetos con propiedad createdAt (formato ISO)
   * @param {number} daysAgo - Cantidad de días atrás desde hoy
   * @returns {Array} - Lista filtrada
   */
  const filterItemsCreatedBefore = (items, daysAgo) => {
    const cutoffDate = new Date()
    cutoffDate.setDate(cutoffDate.getDate() - daysAgo)

    return items.filter(item => new Date(item.createdAt) > cutoffDate)
  }

  const fetchLastestPOBoxe = async () => {
    try {
      const poBoxes = await getPoBoxesByDate();
      const filteredItems = filterItemsCreatedBefore(poBoxes, 30)
      setPoBoxes(filteredItems);
      
      const byDate = groupByDates(filteredItems);
      setGroupBydate(byDate)
    } catch (err) {
      errorHandler(err)
    } finally {
    }
  }

  const groupByDates = (items) => {
    return items.reduce((acc, item) => {
      const created = moment(item.createdAt)

      if (created.isSame(moment(), 'day')) acc.today++
      else if (created.isSame(moment().subtract(1, 'day'), 'day')) acc.yesterday++

      if (created.isSame(moment(), 'week')) acc.thisWeek++
      if (created.isSame(moment(), 'month')) acc.thisMonth++

      return acc
    }, {
      today: 0,
      yesterday: 0,
      thisWeek: 0,
      thisMonth: 0,
    })
  }

  const renderPoBoxes = () => {
    return poBoxes.map(pb => {
      const fecha = moment(pb.createdAt)
      const preAlerts = pb.boxes?.items?.length || 0;

      return (
        <tr>
          <td>{PO_BOX_PREFIX} {pb.boxNumber}</td>
          <td>{pb.name}</td>
          <td>{pb.phone}</td>
          <td>{fecha.format("DD-MM-yyyy")}</td>
          <td> {preAlerts}</td>
        </tr>
      )
    });
  }

  return (
    <Row className={cx([className, "mb-4"])}>
      <Col lg={3}>
        <Card>
          <CardBody>
            <CardTitle tag="h5">
              Casilleros Creados
            </CardTitle>
            <CardText>
              <Table>
                <tbody>
                  <tr>
                    <td>Hoy</td>
                    <td>{groupBydate.today || 0}</td>
                  </tr>
                  <tr>
                    <td>Ayer</td>
                    <td>{groupBydate.yesterday || 0}</td>
                  </tr>
                  <tr>
                    <td>Esta Semana</td>
                    <td>{groupBydate.thisWeek || 0}</td>
                  </tr>
                  <tr>
                    <td>Este Mes</td>
                    <td>{groupBydate.thisMonth || 0}</td>
                  </tr>
                </tbody>
              </Table>
            </CardText>
          </CardBody>
        </Card >
      </Col>
      <Col>
        <Card>
          <CardBody>
            <CardTitle tag="h5">
              Lista de Casilleros
            </CardTitle>
            <CardText>
              <Table responsive>
                <thead>
                  <tr>
                    <th># Casillero</th>
                    <th>Nombre</th>
                    <th>Telefono</th>
                    <th>Dia Creacion</th>
                    <th>PreAlertas</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {renderPoBoxes()}
                </tbody>
              </Table>
            </CardText>
          </CardBody>
        </Card>
      </Col>
    </Row >
  );
}

export default NewUserPOBoxes;
